var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 78,
    viewBox: "0 0 92 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vectors"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.1101 63.5679L49.8762 66.1345C49.591 66.4672 49.6543 67.0851 50.0028 67.5287L52.2051 70.2696C52.5695 70.7133 53.1558 70.9192 53.536 70.6974L56.4829 69.0972C58.3682 70.7133 60.5864 71.9807 63.058 72.7412L63.2797 76.0525C63.3114 76.4961 63.7867 76.8922 64.357 76.9556L67.8426 77.3358C68.413 77.3992 68.9676 77.114 69.0943 76.7021L70.0449 73.5176C72.6116 73.3116 75.0514 72.5669 77.2537 71.3945L79.7887 73.5968C80.1214 73.882 80.7393 73.8186 81.1829 73.47L83.9238 71.2678C84.3674 70.9034 84.5734 70.3172 84.3516 69.9369L82.7197 66.9425C84.2882 65.073 85.4924 62.8707 86.2212 60.4308L89.7067 60.1932C90.1503 60.1615 90.5464 59.6862 90.6097 59.1158L90.9901 55.6303C91.0534 55.0599 90.7682 54.5054 90.3563 54.3786L86.9499 53.3646C86.7122 50.893 85.9993 48.5482 84.8744 46.441L87.2668 43.7001C87.552 43.3674 87.4886 42.7495 87.14 42.3059L84.9378 39.565C84.5734 39.1213 83.9872 38.9154 83.6069 39.1372L80.359 40.8958C78.5529 39.3907 76.4457 38.2182 74.1167 37.4894L73.8631 33.7662C73.8315 33.3226 73.3562 32.9265 72.7858 32.8631L69.3003 32.4829C68.7299 32.4195 68.1754 32.7047 68.0486 33.1166L66.9871 36.6814C64.5631 36.8874 62.2499 37.5687 60.1586 38.646L57.3701 36.222C57.0374 35.9368 56.4195 36.0001 55.9759 36.3487L53.235 38.551C52.7914 38.9154 52.5854 39.5016 52.8072 39.8818L54.55 43.0822C52.9973 44.9042 51.7773 47.0272 51.0168 49.3879L47.4679 49.6256C47.0243 49.6572 46.6282 50.1326 46.5648 50.7029L46.1846 54.1885C46.1212 54.7589 46.4064 55.3134 46.8184 55.4401L50.1613 56.4383",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.115 19.7594C33.115 10.9029 25.6527 3.80502 16.6853 4.37539C9.06455 4.86653 2.8539 11.0455 2.33107 18.6662C1.99835 23.4826 3.86784 27.8554 7.03654 30.8974C8.89023 32.6877 10.1894 34.9692 10.6013 37.52L11.045 40.3243C11.3143 41.9878 12.756 43.2236 14.4513 43.2236H20.9472C22.6424 43.2236 24.0841 41.9878 24.3535 40.3243L24.7971 37.52C25.1932 35.0642 26.334 32.7827 28.156 31.1033C29.3759 29.9626 30.4216 28.6476 31.2296 27.1583",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.341 43.9529H13.0409C12.3409 43.9529 11.7734 44.5204 11.7734 45.2204C11.7734 45.9204 12.3409 46.4879 13.0409 46.4879H22.341C23.041 46.4879 23.6085 45.9204 23.6085 45.2204C23.6085 44.5204 23.041 43.9529 22.341 43.9529Z",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.341 47.3904H13.0409C12.3409 47.3904 11.7734 47.9579 11.7734 48.6579C11.7734 49.3579 12.3409 49.9254 13.0409 49.9254H22.341C23.041 49.9254 23.6085 49.3579 23.6085 48.6579C23.6085 47.9579 23.041 47.3904 22.341 47.3904Z",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.2321 50.8132H14.1659C13.4659 50.8132 12.8984 51.3807 12.8984 52.0807C12.8984 52.7807 13.4659 53.3482 14.1659 53.3482H21.2321C21.9321 53.3482 22.4996 52.7807 22.4996 52.0807C22.4996 51.3807 21.9321 50.8132 21.2321 50.8132Z",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M69.3329 25.939V4.0275C69.3329 2.15797 70.838 0.652832 72.7076 0.652832H72.7551C74.6247 0.652832 76.1298 2.15797 76.1298 4.0275C76.1298 5.89703 74.6247 7.40213 72.7551 7.40213H46.1855",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.79692 48.6587V70.5702C7.79692 72.4398 6.29178 73.9449 4.42225 73.9449H4.37467C2.50514 73.9449 1 72.4398 1 70.5702C1 68.7007 2.50514 67.1956 4.37467 67.1956H30.9443",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M58.6701 59.7966H26.5078",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M58.6701 23.7688H26.5078",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M53.7109 18.8093L58.67 23.7683L53.7109 28.7432",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M30.9434 64.7556L25.9844 59.7966L30.9434 54.8376",
    stroke: "#C7D0CF",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M68.5563 62.9656C73.0014 62.9656 76.6049 59.3623 76.6049 54.9172C76.6049 50.4721 73.0014 46.8687 68.5563 46.8687C64.1113 46.8687 60.5078 50.4721 60.5078 54.9172C60.5078 59.3623 64.1113 62.9656 68.5563 62.9656Z",
    fill: "#236F5E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferSvg2);
export default __webpack_public_path__ + "static/media/offer-svg-2.7f220a14204d00262bde4fc37f329397.svg";
export { ForwardRef as ReactComponent };